import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

Vue.use(VueAxios, axios)

const instance = axios.create();

const servicesAPI = {
  getConversations() {
    var url = ConfigAPI.baseURL + "messages/conversations" + Session.getToken();
    return instance.get(url);
  },
  getUnreadCount() {
    var url = ConfigAPI.baseURL + "messages/unread-count" + Session.getToken();
    return instance.get(url);
  },
  startConversation(staffId) {
    var params = {
      staff_id: staffId
    }
    var url = ConfigAPI.baseURL + "messages/conversations" + Session.getToken();
    return instance.post(url, params);
  },
  filterStaffByName(data) {
    var params = {
      name: data.name
    }
    var url = ConfigAPI.baseURL + "staff/filter/name" + Session.getToken();
    return instance.post(url, params);
  },
  getMessages(conversationId) {
    var url = ConfigAPI.baseURL + "messages/conversations/" + conversationId + "/messages" + Session.getToken();
    return instance.get(url);
  },
  sendMessage(conversationId, body) {
    var params = {
      body: body
    }
    var url = ConfigAPI.baseURL + "messages/conversations/" + conversationId + "/messages" + Session.getToken();
    return instance.post(url, params);
  },
  markUnread(conversationId) {
    var url = ConfigAPI.baseURL + "messages/conversations/" + conversationId + "/mark-unread" + Session.getToken();
    return instance.post(url);
  }
}

export default servicesAPI;
